import { MemberFormEffects } from './member-form.effect';

export const effects = [MemberFormEffects];
export * from './member-form.effect';
